import { combineReducers } from 'redux'

import interestProfiler from './assessments/interestProfiler'
import budget from './assessments/budget'
import workImportanceProfiler from './assessments/workImportanceProfiler'
import skillsProfiler from './assessments/skillsProfiler'
import workKeys from './assessments/workKeys'
import skillsDecoder from './assessments/skillsDecoder'

import * as h2Api from '../h2Api'
import { IP_RESULTS, IP_SUMMARY } from '../actions/assessments/interestProfiler'
import { QUICK_RESULTS } from '../actions/assessments/quick'
import { LONG_IP_RESULTS } from '../actions/assessments/longInterestProfiler'

const assessments = combineReducers({
  interestProfiler,
  interestProfilerSummary: h2Api.restReducer(IP_SUMMARY),
  interestProfilerResults: h2Api.restReducer(IP_RESULTS),
  longInterestProfilerResults: h2Api.restReducer(LONG_IP_RESULTS),
  quickResults: h2Api.restReducer(QUICK_RESULTS),
  workImportanceProfiler,
  skillsProfiler,
  skillsDecoder,
  workKeys,
  budget
})

export default assessments
